import React, { useState } from "react";
import { Card, Form, Button, Alert, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "../services/axiosInterceptor";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

export default function ChangePassword() {
  const [skin, setSkin] = useState(localStorage.getItem("skin-mode") ? "dark" : "");
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [alert, setAlert] = useState(null); // { type: 'success'|'danger', message: string }
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(null);

    if (form.newPassword.length < 6) {
      setAlert({ type: "danger", message: "รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร" });
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setAlert({ type: "danger", message: "รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน" });
      return;
    }

    setLoading(true);
    try {
      await axiosInstance.post("/api/auth/change-password", {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
        confirmPassword: form.confirmPassword,
      });
      setAlert({ type: "success", message: "เปลี่ยนรหัสผ่านสำเร็จ" });
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      const message = err.response?.data?.error || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
      setAlert({ type: "danger", message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <ol className="breadcrumb fs-sm mb-2">
          <li className="breadcrumb-item"><Link to="/dashboard/school-statistic">หน้าหลัก</Link></li>
          <li className="breadcrumb-item active" aria-current="page">เปลี่ยนรหัสผ่าน</li>
        </ol>
        <h2 className="main-title">เปลี่ยนรหัสผ่าน</h2>

        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="card-settings">
              <Card.Header>
                <Card.Title>ตั้งค่ารหัสผ่านใหม่</Card.Title>
                <Card.Text>กรอกรหัสผ่านปัจจุบันและรหัสผ่านใหม่ที่ต้องการ</Card.Text>
              </Card.Header>
              <Card.Body>
                {alert && (
                  <Alert variant={alert.type} dismissible onClose={() => setAlert(null)}>
                    {alert.message}
                  </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>รหัสผ่านปัจจุบัน</Form.Label>
                    <Form.Control
                      type="password"
                      name="currentPassword"
                      value={form.currentPassword}
                      onChange={handleChange}
                      required
                      autoComplete="current-password"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>รหัสผ่านใหม่</Form.Label>
                    <Form.Control
                      type="password"
                      name="newPassword"
                      value={form.newPassword}
                      onChange={handleChange}
                      required
                      minLength={6}
                      autoComplete="new-password"
                    />
                    <Form.Text className="text-muted">อย่างน้อย 6 ตัวอักษร</Form.Text>
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>ยืนยันรหัสผ่านใหม่</Form.Label>
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      value={form.confirmPassword}
                      onChange={handleChange}
                      required
                      autoComplete="new-password"
                    />
                  </Form.Group>
                  <Button type="submit" variant="primary" className="w-100" disabled={loading}>
                    {loading ? "กำลังบันทึก..." : "เปลี่ยนรหัสผ่าน"}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
